import { ArrowUpRight, ArrowDownRight } from 'lucide-react'; // You can replace with your own SVGs or images

export default function TrendPercentage({ up = 81, down = 19 }) {
  const total = up + down;
  const upPercent = (up / total) * 100;
  const downPercent = (down / total) * 100;

  return (
    <div className="trend_precentage" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <ArrowUpRight color="#00C292" size={20} />
      <span style={{ color: '#00C292', fontWeight: 'bold' }}>{up}%</span>

      <div style={{
        flexGrow: 1,
        height: '20px',
        borderRadius: '999px',
        overflow: 'hidden',
        display: 'flex',
        backgroundColor: '#e0e0e0',
        width: '200px'
      }}>
        <div style={{
          width: `${upPercent}%`,
          backgroundColor: '#00C292'
        }} />
        <div style={{
          width: `${downPercent}%`,
          backgroundColor: '#F44336'
        }} />
      </div>

      <span style={{ color: '#F44336', fontWeight: 'bold' }}>{down}%</span>
      <ArrowDownRight color="#F44336" size={20} />
    </div>
  );
}
